import { Cookies } from 'react-cookie'
import {
  AUTH_BEARER_TOKEN_COOKIE_NAME,
  BUSINESS_TRAVELLER_AUTH_COOKIE_DOMAIN,
  isBusinessTravellerHostname,
} from '../../auth/authCookies'

const AUTH_COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60 // 1 year
const AUTH_COOKIE_PATH_OPTIONS = { path: '/' }
const AUTH_COOKIE_OPTIONS = {
  ...AUTH_COOKIE_PATH_OPTIONS,
  maxAge: AUTH_COOKIE_MAX_AGE_SECONDS,
  secure: process.env.NODE_ENV === 'production',
}
const BUSINESS_TRAVELLER_DOMAIN_COOKIE_OPTIONS = {
  ...AUTH_COOKIE_OPTIONS,
  domain: BUSINESS_TRAVELLER_AUTH_COOKIE_DOMAIN,
}

export function setAuthCookies(accessToken?: string) {
  if (!accessToken) return

  const cookies = new Cookies()

  removeAuthCookies()

  cookies.set(AUTH_BEARER_TOKEN_COOKIE_NAME, accessToken, AUTH_COOKIE_OPTIONS)
  if (isBusinessTravellerHostname(window.location.hostname)) {
    cookies.set(AUTH_BEARER_TOKEN_COOKIE_NAME, accessToken, BUSINESS_TRAVELLER_DOMAIN_COOKIE_OPTIONS)
  }
}

export function removeAuthCookies() {
  const cookies = new Cookies()

  cookies.remove(AUTH_BEARER_TOKEN_COOKIE_NAME, AUTH_COOKIE_PATH_OPTIONS)
  cookies.remove(AUTH_BEARER_TOKEN_COOKIE_NAME, { ...AUTH_COOKIE_PATH_OPTIONS, domain: window.location.hostname })
  cookies.remove(AUTH_BEARER_TOKEN_COOKIE_NAME, { ...AUTH_COOKIE_PATH_OPTIONS, domain: BUSINESS_TRAVELLER_AUTH_COOKIE_DOMAIN })
}
